import Loader from 'react-ts-loaders';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import css from './edit-in-constructor.module.scss';
import { MainButton } from '../../../../../../ui/main-button/main-button';
import { useIsMounted } from '../../../../../../../hooks/lifecycle/useIsMounted';
import { templatePrivateAPI } from '../../../../../../../entities/template/private-template/api/api';
import { useAppDispatch } from '../../../../../../../shared/libs/redux';

interface IEditInConstructorProps {
	id: string | null,
	onClose: () => void,
}

export const EditInConstructor = (props: IEditInConstructorProps) => {
	const { id, onClose } = props;
	const navigate = useNavigate();
	const isMounted = useIsMounted();
	const dispatch = useAppDispatch();

	const [isConstructorLoading, setIsConstructorLoading] = useState(false);

	const onInConstructor = () => {
		setIsConstructorLoading(true);
		try {
			onClose();
			navigate(`/constructor/${id}`);
			dispatch(templatePrivateAPI.util?.invalidateTags(['templates']));
		} catch (error) {
			console.log(`Ошибка: ${error}`);
		} finally {
			if (isMounted.current) {
				setIsConstructorLoading(false);
			}
		}
	};

	return (
		<MainButton
			btnStyle="bright"
			type="button"
			onClick={onInConstructor}
			disabled={isConstructorLoading}
		>
			{
				isConstructorLoading ? (
					<div className={css.buttonContent}>
						Редактировать в конструкторе
						<Loader
							className={css.constructorLoader}
							type="ring"
							color="#d8d7d7"
							size={18}
						/>
					</div>
				) : (
					'Редактировать в конструкторе'
				)
			}
		</MainButton>
	);
};
